import {
  LOGINLOGLIST} from '../actions/loginlog';
import {reducerPackage} from "../../utils";


export const loginlogList = reducerPackage(LOGINLOGLIST);

